import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {colors} from '../colors/colors';
import {Link} from '../link/link';
import {StageIndicator} from '../stage-indicator/stage-indicator';

type Props = {
    htmlUrlPath: string;
    name: string;
    totalSent: number;
    length: number;
};

export function SequenceProgress(props: Props) {
    return (
        <>
            {/* @ts-expect-error */}
            <Link to={props.htmlUrlPath} as={RoutedLink} variant='primary' size='small'>
                {props.name}
            </Link>
            <StageIndicator
                currentStage={props.totalSent}
                numStages={props.length}
                customColor={colors.reportGreen}
                height={15}
            />
        </>
    );
}
